<div class="d-flex justify-content-center fs-1">
  <button class="camera-trigger-button" type="button" (click)="openCamera()" aria-label="Abrir cámara">
    <i class="fa fa-camera cursor-pointer" aria-hidden="true"></i>
  </button>
</div>

<p-dialog header="Cámara" [(visible)]="cameraIsVisible" (onShow)="startCamera()" (onHide)="closeCamera()">
  <div class="camera-dialog-content mx-auto">
    <p-panel>
      @if (cameraIsLoading) {
        <div class="d-inline-block me-2 position-relative top-1">
          <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="6" animationDuration="1.5s"></p-progressSpinner>
        </div>
      }

      @if (cameraError) {
        <div class="camera-error" role="alert">{{ cameraError }}</div>
      }

      @if (photoIsDisplayed) {
        <p>Volver a la cámara, pulsa sobre la pantalla</p>
        <div class="d-flex justify-content-center">
          <button class="camera-preview-button" type="button" (click)="discardPhoto()">
            <img #imageTag class="img-fluid" alt="cámara">
          </button>
        </div>
      } @else {
        <p>Pulsa sobre la pantalla para hacer una captura</p>
        <div class="d-flex justify-content-center">
          <video #videoTag autoplay playsinline muted class="img-fluid"></video>
        </div>
      }
    </p-panel>

    <div class="d-flex justify-content-center mt-4">
      <button class="btn btn-dark mx-2" type="button" (click)="closeCamera()">Cerrar</button>
      @if (photoIsDisplayed) {
        <button class="btn btn-danger mx-2" type="button" (click)="discardPhoto()">
          <i class="fa fa-trash fs-4" aria-hidden="true"></i>
        </button>
      } @else {
        <button class="btn btn-success mx-2" type="button" [disabled]="cameraIsLoading" (click)="takePhoto()">
          <i class="fa fa-camera fs-4" aria-hidden="true"></i>
        </button>
      }
    </div>
  </div>
</p-dialog>
